/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import Slider from "react-slick";
import { t } from 'i18next';

import { AiFillCaretLeft, AiFillCaretRight} from "react-icons/ai";

import image1 from "../../images_previousExpo2019/previous_expo_2019 (1).jpg"
import image2 from "../../images_previousExpo2019/previous_expo_2019 (2).jpg"
import image3 from "../../images_previousExpo2019/previous_expo_2019 (3).jpg"
import image4 from "../../images_previousExpo2019/previous_expo_2019 (4).jpg"
import image5 from "../../images_previousExpo2019/previous_expo_2019 (5).jpg"
import image6 from "../../images_previousExpo2019/previous_expo_2019 (6).jpg"
import image7 from "../../images_previousExpo2019/previous_expo_2019 (7).jpg"
import image8 from "../../images_previousExpo2019/previous_expo_2019 (8).jpg"
import image9 from "../../images_previousExpo2019/previous_expo_2019 (9).jpg"
import image10 from "../../images_previousExpo2019/previous_expo_2019 (10).jpg"
import image11 from "../../images_previousExpo2019/previous_expo_2019 (11).jpg"
import image12 from "../../images_previousExpo2019/previous_expo_2019 (12).jpg"

import "../../Components/Slider/slick.css";
import "../../Components/Slider/slick-poster-theme.css";

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const GalleryPrevious2019 = () => {
    let slidesToShow = Math.floor(window.innerWidth/800)
    if(slidesToShow === 0){
        slidesToShow = 1
    }
    const settings = {
        arrows:false,
        dots: true,
        infinite: true,
        speed: 500,
        // centerMode : true,
        slidesToShow:slidesToShow,
        slidesToScroll:1
    };

    const listimg = [image1, image2, image3, image4, image5, image6, image7, image8, image9, image10, image11, image12];
    
    return(
        <div className="sect-01-box-01-gallery margin-top-100 margin-btm-100">
            <div className="sect-03-tit-01 sect-tit">{t("gallery_prev2019_title")}</div>
            <div className='gallery-poster-wrap'>
                <Slider {...settings}>
                    {function(){
                        const imgSliderCont = []
                        for (let j = 0; j < listimg.length; j ++){
                            imgSliderCont.push(
                            <div className='gallery-prev2019-img-box-wrap'>
                                <div className='gallery-prev2019-img-box'>
                                    <img src={listimg[j]}/>
                                </div>
                            </div>)
                        }
                        return imgSliderCont
                    }()}
                </Slider>
            </div>
        </div>
    )
}

export default GalleryPrevious2019;